import { Fragment, useContext } from "react"
import { useSearchParams } from "react-router-dom"
import { RegisterByGroup, TabNavRegister } from "./components"
import { TabRegisterPath } from "./types"
import { HeaderMenu } from "components"
import { AuthContext } from "contexts"
import { PERMISION } from "security"

type TabsSearchParams = { tabs: TabRegisterPath }
 
export default function AssetManagementRegister() {
  const { permission: list } = useContext(AuthContext)
  const [searchParams, setSearchParams] = useSearchParams({ tabs: Boolean(list.find((val) => val.startsWith(PERMISION.ASET_MANAGEMENT.REGISTER.BY_GROUP.PERMISION))) ? "by-group" : "" } as TabsSearchParams)
  const activeTab = searchParams.get("tabs")
  const setActiveTab = (path: string) => setSearchParams({ tabs: path })

  return (
    <Fragment>
      <section className="container my-5">
        <HeaderMenu title="ASSET MANAGEMENT REGISTER" />

        <section className="mt-1">
          <TabNavRegister activeTab={activeTab!} setActiveTab={setActiveTab} />
          {activeTab === "by-group" && <RegisterByGroup />}
        </section>
      </section>
    </Fragment>
  )
}
